/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint-disable indent */
/* eslint-disable no-unused-expressions */
export const regions_communes = [
  {
    "value": 0,
    "label": "Arica y Parinacota",
    "communes": [
      {
        "value": "15101",
        "label": "Arica"
      },
      {
        "value": "15102",
        "label": "Camarones"
      },
      {
        "value": "15201",
        "label": "Putre"
      },
      {
        "value": "15202",
        "label": "General Lagos"
      }
    ]
  },
  {
    "value": 1,
    "label": "Tarapacá",
    "communes": [
      {
        "value": "01101",
        "label": "Iquique"
      },
      {
        "value": "01102",
        "label": "Alto Hospicio"
      },
      {
        "value": "01201",
        "label": "Pozo Almonte"
      },
      {
        "value": "01402",
        "label": "Camiña"
      },
      {
        "value": "01403",
        "label": "Colchane"
      },
      {
        "value": "01404",
        "label": "Huara"
      },
      {
        "value": "01405",
        "label": "Pica"
      }
    ]
  },
  {
    "value": 2,
    "label": "Antofagasta",
    "communes": [
      {
        "value": "02101",
        "label": "Antofagasta"
      },
      {
        "value": "02102",
        "label": "Mejillones"
      },
      {
        "value": "02103",
        "label": "Sierra Gorda"
      },
      {
        "value": "02104",
        "label": "Taltal"
      },
      {
        "value": "02201",
        "label": "Calama"
      },
      {
        "value": "02202",
        "label": "Ollagüe"
      },
      {
        "value": "02203",
        "label": "San Pedro de Atacama"
      },
      {
        "value": "02301",
        "label": "Tocopilla"
      },
      {
        "value": "02302",
        "label": "María Elena"
      }
    ]
  },
  {
    "value": 3,
    "label": "Atacama",
    "communes": [
      {
        "value": "03101",
        "label": "Copiapó"
      },
      {
        "value": "03102",
        "label": "Caldera"
      },
      {
        "value": "03103",
        "label": "Tierra Amarilla"
      },
      {
        "value": "03201",
        "label": "Chañaral"
      },
      {
        "value": "03202",
        "label": "Diego de Almagro"
      },
      {
        "value": "03301",
        "label": "Vallenar"
      },
      {
        "value": "03302",
        "label": "Alto del Carmen"
      },
      {
        "value": "03303",
        "label": "Freirina"
      },
      {
        "value": "03304",
        "label": "Huasco"
      }
    ]
  },
  {
    "value": 4,
    "label": "Coquimbo",
    "communes": [
      {
        "value": "04101",
        "label": "La Serena"
      },
      {
        "value": "04102",
        "label": "Coquimbo"
      },
      {
        "value": "04103",
        "label": "Andacollo"
      },
      {
        "value": "04104",
        "label": "La Higuera"
      },
      {
        "value": "04105",
        "label": "Paiguano"
      },
      {
        "value": "04106",
        "label": "Vicuña"
      },
      {
        "value": "04201",
        "label": "Illapel"
      },
      {
        "value": "04202",
        "label": "Canela"
      },
      {
        "value": "04203",
        "label": "Los Vilos"
      },
      {
        "value": "04204",
        "label": "Salamanca"
      },
      {
        "value": "04301",
        "label": "Ovalle"
      },
      {
        "value": "04302",
        "label": "Combarbalá"
      },
      {
        "value": "04303",
        "label": "Monte Patria"
      },
      {
        "value": "04304",
        "label": "Punitaqui"
      },
      {
        "value": "04305",
        "label": "Río Hurtado"
      }
    ]
  },
  {
    "value": 5,
    "label": "Valparaíso",
    "communes": [
      {
        "value": "05101",
        "label": "Valparaíso"
      },
      {
        "value": "05102",
        "label": "Casablanca"
      },
      {
        "value": "05103",
        "label": "Concón"
      },
      {
        "value": "05104",
        "label": "Juan Fernández"
      },
      {
        "value": "05105",
        "label": "Puchuncaví"
      },
      {
        "value": "05107",
        "label": "Quintero"
      },
      {
        "value": "05109",
        "label": "Viña del Mar"
      },
      {
        "value": "05201",
        "label": "Isla de Pascua"
      },
      {
        "value": "05301",
        "label": "Los Andes"
      },
      {
        "value": "05302",
        "label": "Calle Larga"
      },
      {
        "value": "05303",
        "label": "Riconada"
      },
      {
        "value": "05304",
        "label": "San Esteban"
      },
      {
        "value": "05401",
        "label": "La Ligua"
      },
      {
        "value": "05402",
        "label": "Cabildo"
      },
      {
        "value": "05403",
        "label": "Papudo"
      },
      {
        "value": "05404",
        "label": "Petorca"
      },
      {
        "value": "05405",
        "label": "Zapallar"
      },
      {
        "value": "05501",
        "label": "Quillota"
      },
      {
        "value": "05502",
        "label": "Calera"
      },
      {
        "value": "05503",
        "label": "Hijuelas"
      },
      {
        "value": "05504",
        "label": "La Cruz"
      },
      {
        "value": "05506",
        "label": "Nogales"
      },
      {
        "value": "05601",
        "label": "San Antonio"
      },
      {
        "value": "05602",
        "label": "Algarrobo"
      },
      {
        "value": "05603",
        "label": "Cartagena"
      },
      {
        "value": "05604",
        "label": "El Quisco"
      },
      {
        "value": "05605",
        "label": "El Tabo"
      },
      {
        "value": "05606",
        "label": "Santo Domingo"
      },
      {
        "value": "05701",
        "label": "San Felipe"
      },
      {
        "value": "05702",
        "label": "Catemu"
      },
      {
        "value": "05703",
        "label": "Llaillay"
      },
      {
        "value": "05704",
        "label": "Panquehue"
      },
      {
        "value": "05705",
        "label": "Putaendo"
      },
      {
        "value": "05706",
        "label": "Santa María"
      },
      {
        "value": "05801",
        "label": "Quilpué"
      },
      {
        "value": "05802",
        "label": "Limache"
      },
      {
        "value": "05803",
        "label": "Olmué"
      },
      {
        "value": "05804",
        "label": "Villa Alemana"
      }
    ]
  },
  {
    "value": 6,
    "label": "Región del Libertador Gral. Bernardo O'Higgins",
    "communes": [
      {
        "value": "06101",
        "label": "Rancagua"
      },
      {
        "value": "06102",
        "label": "Codegua"
      },
      {
        "value": "06103",
        "label": "Coinco"
      },
      {
        "value": "06104",
        "label": "Coltauco"
      },
      {
        "value": "06105",
        "label": "Doñihue"
      },
      {
        "value": "06106",
        "label": "Graneros"
      },
      {
        "value": "06107",
        "label": "Las Cabras"
      },
      {
        "value": "06108",
        "label": "Machalí"
      },
      {
        "value": "06109",
        "label": "Malloa"
      },
      {
        "value": "06110",
        "label": "Mostazal"
      },
      {
        "value": "06111",
        "label": "Olivar"
      },
      {
        "value": "06112",
        "label": "Peumo"
      },
      {
        "value": "06113",
        "label": "Pichidegua"
      },
      {
        "value": "06114",
        "label": "Quinta de Tilcoco"
      },
      {
        "value": "06115",
        "label": "Rengo"
      },
      {
        "value": "06116",
        "label": "Requínoa"
      },
      {
        "value": "06117",
        "label": "San Vicente"
      },
      {
        "value": "06201",
        "label": "Pichilemu"
      },
      {
        "value": "06202",
        "label": "La Estrella"
      },
      {
        "value": "06203",
        "label": "Litueche"
      },
      {
        "value": "06204",
        "label": "Marichihue"
      },
      {
        "value": "06205",
        "label": "Navidad"
      },
      {
        "value": "06206",
        "label": "Paredones"
      },
      {
        "value": "06301",
        "label": "San Fernando"
      },
      {
        "value": "06302",
        "label": "Chépica"
      },
      {
        "value": "06303",
        "label": "Chimbarongo"
      },
      {
        "value": "06304",
        "label": "Lolol"
      },
      {
        "value": "06305",
        "label": "Nancagua"
      },
      {
        "value": "06306",
        "label": "Palmilla"
      },
      {
        "value": "06307",
        "label": "Peralillo"
      },
      {
        "value": "06308",
        "label": "Placilla"
      },
      {
        "value": "06309",
        "label": "Pumanque"
      },
      {
        "value": "06310",
        "label": "Santa Cruz"
      }
    ]
  },
  {
    "value": 7,
    "label": "Región del Maule",
    "communes": [
      {
        "value": "07101",
        "label": "Talca"
      },
      {
        "value": "07102",
        "label": "Constitución"
      },
      {
        "value": "07103",
        "label": "Curepto"
      },
      {
        "value": "07104",
        "label": "Empedrado"
      },
      {
        "value": "07105",
        "label": "Maule"
      },
      {
        "value": "07106",
        "label": "Pelarco"
      },
      {
        "value": "07107",
        "label": "Pencahue"
      },
      {
        "value": "07108",
        "label": "Río Claro"
      },
      {
        "value": "07109",
        "label": "San Clemente"
      },
      {
        "value": "07110",
        "label": "San Rafael"
      },
      {
        "value": "07201",
        "label": "Cauquenes"
      },
      {
        "value": "07202",
        "label": "Chanco"
      },
      {
        "value": "07203",
        "label": "Pelluhue"
      },
      {
        "value": "07301",
        "label": "Curicó"
      },
      {
        "value": "07302",
        "label": "Hualañé"
      },
      {
        "value": "07303",
        "label": "Licantén"
      },
      {
        "value": "07304",
        "label": "Molina"
      },
      {
        "value": "07305",
        "label": "Rauco"
      },
      {
        "value": "07306",
        "label": "Romeral"
      },
      {
        "value": "07307",
        "label": "Sagrada Familia"
      },
      {
        "value": "07308",
        "label": "Teno"
      },
      {
        "value": "07309",
        "label": "Vichuquén"
      },
      {
        "value": "07401",
        "label": "Linares"
      },
      {
        "value": "07402",
        "label": "Colbún"
      },
      {
        "value": "07403",
        "label": "Longaví"
      },
      {
        "value": "07404",
        "label": "Parral"
      },
      {
        "value": "07405",
        "label": "Retiro"
      },
      {
        "value": "07406",
        "label": "San Javier"
      },
      {
        "value": "07407",
        "label": "Villa Alegre"
      },
      {
        "value": "07408",
        "label": "Yerbas Buenas"
      }
    ]
  },
  {
    "value": 8,
    "label": "Región del Biobío",
    "communes": [
      {
        "value": "08101",
        "label": "Concepción"
      },
      {
        "value": "08102",
        "label": "Coronel"
      },
      {
        "value": "08103",
        "label": "Chiguayante"
      },
      {
        "value": "08104",
        "label": "Florida"
      },
      {
        "value": "08105",
        "label": "Hualqui"
      },
      {
        "value": "08106",
        "label": "Lota"
      },
      {
        "value": "08107",
        "label": "Penco"
      },
      {
        "value": "08108",
        "label": "San Pedro de la Paz"
      },
      {
        "value": "08109",
        "label": "Santa Juana"
      },
      {
        "value": "08110",
        "label": "Talcahuano"
      },
      {
        "value": "08111",
        "label": "Tomé"
      },
      {
        "value": "08112",
        "label": "Hualpén"
      },
      {
        "value": "08201",
        "label": "Lebu"
      },
      {
        "value": "08202",
        "label": "Arauco"
      },
      {
        "value": "08203",
        "label": "Cañete"
      },
      {
        "value": "08204",
        "label": "Contulmo"
      },
      {
        "value": "08205",
        "label": "Curanilahue"
      },
      {
        "value": "08206",
        "label": "Los Álamos"
      },
      {
        "value": "08207",
        "label": "Tirúa"
      },
      {
        "value": "08301",
        "label": "Los Ángeles"
      },
      {
        "value": "08302",
        "label": "Antuco"
      },
      {
        "value": "08303",
        "label": "Cabrero"
      },
      {
        "value": "08304",
        "label": "Laja"
      },
      {
        "value": "08305",
        "label": "Mulchén"
      },
      {
        "value": "08306",
        "label": "Nacimiento"
      },
      {
        "value": "08307",
        "label": "Negrete"
      },
      {
        "value": "08308",
        "label": "Quilaco"
      },
      {
        "value": "08309",
        "label": "Quilleco"
      },
      {
        "value": "08310",
        "label": "San Rosendo"
      },
      {
        "value": "08311",
        "label": "Santa Bárbara"
      },
      {
        "value": "08312",
        "label": "Tucapel"
      },
      {
        "value": "08313",
        "label": "Yumbel"
      },
      {
        "value": "08314",
        "label": "Alto Biobío"
      },
      {
        "value": "08401",
        "label": "Chillán"
      },
      {
        "value": "08402",
        "label": "Bulnes"
      },
      {
        "value": "08403",
        "label": "Cobquecura"
      },
      {
        "value": "08404",
        "label": "Coelemu"
      },
      {
        "value": "08405",
        "label": "Coihueco"
      },
      {
        "value": "08406",
        "label": "Chillán Viejo"
      },
      {
        "value": "08407",
        "label": "El Carmen"
      },
      {
        "value": "08408",
        "label": "Ninhue"
      },
      {
        "value": "08409",
        "label": "Ñiquén"
      },
      {
        "value": "08410",
        "label": "Pemuco"
      },
      {
        "value": "08411",
        "label": "Pinto"
      },
      {
        "value": "08412",
        "label": "Portezuelo"
      },
      {
        "value": "08413",
        "label": "Quillón"
      },
      {
        "value": "08414",
        "label": "Quirihue"
      },
      {
        "value": "08415",
        "label": "Ránquil"
      },
      {
        "value": "08416",
        "label": "San Carlos"
      },
      {
        "value": "08417",
        "label": "San Fabián"
      },
      {
        "value": "08418",
        "label": "San Ignacio"
      },
      {
        "value": "08419",
        "label": "San Nicolás"
      },
      {
        "value": "08420",
        "label": "Treguaco"
      },
      {
        "value": "08421",
        "label": "Yungay"
      }
    ]
  },
  {
    "value": 9,
    "label": "Región de la Araucanía",
    "communes": [
      {
        "value": "09101",
        "label": "Temuco"
      },
      {
        "value": "09102",
        "label": "Carahu"
      },
      {
        "value": "09103",
        "label": "Cunco"
      },
      {
        "value": "09104",
        "label": "Curarrehue"
      },
      {
        "value": "09105",
        "label": "Freire"
      },
      {
        "value": "09106",
        "label": "Galvarin"
      },
      {
        "value": "09107",
        "label": "Gorbea"
      },
      {
        "value": "09108",
        "label": "Lautaro"
      },
      {
        "value": "09109",
        "label": "Loncoche"
      },
      {
        "value": "09110",
        "label": "Melipeuco"
      },
      {
        "value": "09111",
        "label": "Nueva Imperial"
      },
      {
        "value": "09112",
        "label": "Padre las Casa"
      },
      {
        "value": "09113",
        "label": "Perquenco"
      },
      {
        "value": "09114",
        "label": "Pitrufquén"
      },
      {
        "value": "09115",
        "label": "Pucó"
      },
      {
        "value": "09116",
        "label": "Saavedra"
      },
      {
        "value": "09117",
        "label": "Teodoro Schmid"
      },
      {
        "value": "09118",
        "label": "Toltén"
      },
      {
        "value": "09119",
        "label": "Vilcún"
      },
      {
        "value": "09120",
        "label": "Villarrica"
      },
      {
        "value": "09121",
        "label": "Cholchol"
      },
      {
        "value": "09201",
        "label": "Angol"
      },
      {
        "value": "09202",
        "label": "Collipulli"
      },
      {
        "value": "09203",
        "label": "Curacautín"
      },
      {
        "value": "09204",
        "label": "Ercilla"
      },
      {
        "value": "09205",
        "label": "Lonquimay"
      },
      {
        "value": "09206",
        "label": "Los Sauces"
      },
      {
        "value": "09207",
        "label": "Lumaco"
      },
      {
        "value": "09208",
        "label": "Purén"
      },
      {
        "value": "09209",
        "label": "Renaico"
      },
      {
        "value": "09210",
        "label": "Traiguén"
      },
      {
        "value": "09211",
        "label": "Victoria"
      }
    ]
  },
  {
    "value": 10,
    "label": "Región de los Ríos",
    "communes": [
      {
        "value": "14101",
        "label": "Valdivia"
      },
      {
        "value": "14102",
        "label": "Corral"
      },
      {
        "value": "14103",
        "label": "Lanco"
      },
      {
        "value": "14104",
        "label": "Los Lagos"
      },
      {
        "value": "14105",
        "label": "Máfil"
      },
      {
        "value": "14106",
        "label": "Mariquina"
      },
      {
        "value": "14107",
        "label": "Paillaco"
      },
      {
        "value": "14108",
        "label": "Panguipulli"
      },
      {
        "value": "14201",
        "label": "La Unión"
      },
      {
        "value": "14202",
        "label": "Futrono"
      },
      {
        "value": "14203",
        "label": "Lago Ranco"
      },
      {
        "value": "14204",
        "label": "Río Bueno"
      }
    ]
  },
  {
    "value": 11,
    "label": "Región de los Lagos",
    "communes": [
      {
        "value": "10101",
        "label": "Puerto Montt"
      },
      {
        "value": "10102",
        "label": "Calbuco"
      },
      {
        "value": "10103",
        "label": "Cochamó"
      },
      {
        "value": "10104",
        "label": "Fresia"
      },
      {
        "value": "10105",
        "label": "Frutillar"
      },
      {
        "value": "10106",
        "label": "Los Muermos"
      },
      {
        "value": "10107",
        "label": "Llanquihue"
      },
      {
        "value": "10108",
        "label": "Maullín"
      },
      {
        "value": "10109",
        "label": "Puerto Varas"
      },
      {
        "value": "10201",
        "label": "Castro"
      },
      {
        "value": "10202",
        "label": "Ancud"
      },
      {
        "value": "10203",
        "label": "Chonchi"
      },
      {
        "value": "10204",
        "label": "Curaco de Vélez"
      },
      {
        "value": "10205",
        "label": "Dalcahue"
      },
      {
        "value": "10206",
        "label": "Puqueldón"
      },
      {
        "value": "10207",
        "label": "Queilén"
      },
      {
        "value": "10208",
        "label": "Quellón"
      },
      {
        "value": "10209",
        "label": "Quemchi"
      },
      {
        "value": "10210",
        "label": "Quinchao"
      },
      {
        "value": "10301",
        "label": "Osorno"
      },
      {
        "value": "10302",
        "label": "Puerto Octay"
      },
      {
        "value": "10303",
        "label": "Purranque"
      },
      {
        "value": "10304",
        "label": "Puyehue"
      },
      {
        "value": "10305",
        "label": "Río Negro"
      },
      {
        "value": "10306",
        "label": "San Juan de la Costa"
      },
      {
        "value": "10307",
        "label": "San Pablo"
      },
      {
        "value": "10401",
        "label": "Chaitén"
      },
      {
        "value": "10402",
        "label": "Futaleufú"
      },
      {
        "value": "10403",
        "label": "Hualaihué"
      },
      {
        "value": "10404",
        "label": "Palena"
      }
    ]
  },
  {
    "value": 12,
    "label": "Región Aisén del Gral. Carlos Ibañez del Campo",
    "communes": [
      {
        "value": "11101",
        "label": "Coyhaique"
      },
      {
        "value": "11102",
        "label": "Lago Verde"
      },
      {
        "value": "11201",
        "label": "Aisén"
      },
      {
        "value": "11202",
        "label": "Cisnes"
      },
      {
        "value": "11203",
        "label": "Guaitecas"
      },
      {
        "value": "11301",
        "label": "Cochrane"
      },
      {
        "value": "11302",
        "label": "O’Higgins"
      },
      {
        "value": "11303",
        "label": "Tortel"
      },
      {
        "value": "11401",
        "label": "Chile Chico"
      },
      {
        "value": "11402",
        "label": "Río Ibáñez"
      }
    ]
  },
  {
    "value": 13,
    "label": "Región de Magallanes y de la Antártica Chilena",
    "communes": [
      {
        "value": "12101",
        "label": "Punta Arenas"
      },
      {
        "value": "12102",
        "label": "Laguna Blanca"
      },
      {
        "value": "12103",
        "label": "Río Verde"
      },
      {
        "value": "12104",
        "label": "San Gregorio"
      },
      {
        "value": "12201",
        "label": "Cabo de Hornos (Ex. Navarino)"
      },
      {
        "value": "12202",
        "label": "Antártica"
      },
      {
        "value": "12301",
        "label": "Porvenir"
      },
      {
        "value": "12302",
        "label": "Primavera"
      },
      {
        "value": "12303",
        "label": "Timaukel"
      },
      {
        "value": "12401",
        "label": "Natales"
      },
      {
        "value": "12402",
        "label": "Torres del Paine"
      }
    ]
  },
  {
    "value": 14,
    "label": "Región Metropolitana",
    "communes": [
      {
        "value": "13101",
        "label": "Santiago"
      },
      {
        "value": "13102",
        "label": "Cerrillos"
      },
      {
        "value": "13103",
        "label": "Cerro Navia"
      },
      {
        "value": "13104",
        "label": "Conchalí"
      },
      {
        "value": "13105",
        "label": "El Bosque"
      },
      {
        "value": "13106",
        "label": "Estación Central"
      },
      {
        "value": "13107",
        "label": "Huechuraba"
      },
      {
        "value": "13108",
        "label": "Independencia"
      },
      {
        "value": "13109",
        "label": "La Cisterna"
      },
      {
        "value": "13110",
        "label": "La Florida"
      },
      {
        "value": "13111",
        "label": "La Granja"
      },
      {
        "value": "13112",
        "label": "La Pintana"
      },
      {
        "value": "13113",
        "label": "La Reina"
      },
      {
        "value": "13114",
        "label": "Las Condes"
      },
      {
        "value": "13115",
        "label": "Lo Barnechea"
      },
      {
        "value": "13116",
        "label": "Lo Espejo"
      },
      {
        "value": "13117",
        "label": "Lo Prado"
      },
      {
        "value": "13118",
        "label": "Macul"
      },
      {
        "value": "13119",
        "label": "Maipú"
      },
      {
        "value": "13120",
        "label": "Ñuñoa"
      },
      {
        "value": "13121",
        "label": "Pedro Aguirre Cerda"
      },
      {
        "value": "13122",
        "label": "Peñalolén"
      },
      {
        "value": "13123",
        "label": "Providencia"
      },
      {
        "value": "13124",
        "label": "Pudahuel"
      },
      {
        "value": "13125",
        "label": "Quilicura"
      },
      {
        "value": "13126",
        "label": "Quinta Normal"
      },
      {
        "value": "13127",
        "label": "Recoleta"
      },
      {
        "value": "13128",
        "label": "Renca"
      },
      {
        "value": "13129",
        "label": "San Joaquín"
      },
      {
        "value": "13130",
        "label": "San Miguel"
      },
      {
        "value": "13131",
        "label": "San Ramón"
      },
      {
        "value": "13132",
        "label": "Vitacura"
      },
      {
        "value": "13201",
        "label": "Puente Alto"
      },
      {
        "value": "13202",
        "label": "Pirque"
      },
      {
        "value": "13203",
        "label": "San José de Maipo"
      },
      {
        "value": "13301",
        "label": "Colina"
      },
      {
        "value": "13302",
        "label": "Lampa"
      },
      {
        "value": "13303",
        "label": "Tiltil"
      },
      {
        "value": "13401",
        "label": "San Bernardo"
      },
      {
        "value": "13402",
        "label": "Buin"
      },
      {
        "value": "13403",
        "label": "Calera de Tango"
      },
      {
        "value": "13404",
        "label": "Paine"
      },
      {
        "value": "13501",
        "label": "Melipilla"
      },
      {
        "value": "13502",
        "label": "Alhué"
      },
      {
        "value": "13503",
        "label": "Curacaví"
      },
      {
        "value": "13504",
        "label": "María Pinto"
      },
      {
        "value": "13505",
        "label": "San Pedro"
      },
      {
        "value": "13601",
        "label": "Talagante"
      },
      {
        "value": "13602",
        "label": "El Monte"
      },
      {
        "value": "13603",
        "label": "Isla de Maipo"
      },
      {
        "value": "13604",
        "label": "Padre Hurtado"
      },
      {
        "value": "13605",
        "label": "Peñaflor"
      }
    ]
  }
];
